<template>
  <div>
    <Card title="Net Worth" icon="mdi-egg" wide>
      <div class="net-worth-total">{{ formatMoney(totalNetWorth) }}</div>
      <v-data-table
        :items="accountRows"
        :headers="headers"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:item.balance="{ value }">
          {{ formatMoney(value) }}
        </template>
      </v-data-table>
    </Card>

    <Card title="10 Year Net Worth" icon="mdi-chart-line" wide collapsible @expanded="queryChartData">
      <LineChart
        v-if="chartData"
        :data="chartData"
        :options="{responsive: true, stepped: true, elements: { line: {backgroundColor: 'white', borderColor: 'white', borderWidth: 1}, point:{ pointStyle: false}}, plugins: {legend: {display: false}, tooltip: { callbacks: { label: graphLabel } } }, scales: { y: { ticks: { callback: function(value) {return formatMoney(value); } } }}}"
      />
      <div v-else>
        Loading...
      </div>
    </Card>
  </div>
</template>

<script>
import Card from '@/components/Card'
import { Line as LineChart } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement } from 'chart.js'
import { AccountType } from '@/api'
import { formatMoney } from '@/main'

ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement)

export default {
  name: 'NetWorth',
  components: { Card, LineChart },
  props: ['household', 'financialModule', 'accounts'],
  data: () => ({
    chartData: null,
    headers: [
      { text: 'Account', value: 'name' },
      { text: 'Type', value: 'type' },
      { text: 'Balance', value: 'balance', align: 'end' }
    ]
  }),
  computed: {
    totalNetWorth() {
      return this.accounts.reduce((sum, account) => sum + (account.balanceWithPending || 0), 0)
    },
    accountRows() {
      return [...this.accounts]
        .map(account => ({
          id: account.id,
          name: account.name,
          type: AccountType[account.type] || account.type,
          balance: account.balanceWithPending || 0
        }))
        .sort((a, b) => Math.abs(b.balance) - Math.abs(a.balance))
    }
  },
  methods: {
    graphLabel(context) {
      let label = context.dataset.label || '';

      if (label) {
        label += ': ';
      }
      if (context.parsed.y !== null) {
        label += formatMoney(context.parsed.y);
      }
      return label;
    },
    queryChartData(expanded) {
      if (!expanded || this.chartData)
        return;

      this.$api.financial_investments.getNetWorthMonthlyValues(this.financialModule.id).then((newChartData) => {
        this.chartData = newChartData;
      });
    }
  },
  mounted() {
    this.$emit('breadcrumbs', [
      {
        text: 'Net Worth',
        icon: 'mdi-egg',
        to: '/h/' + this.household.id + '/f/' + this.financialModule.id + '/networth'
      }
    ]);
  }
}
</script>

<style scoped>
.net-worth-total {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 4px;
}

.net-worth-subtitle {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 16px;
}

</style>
